import React from 'react';
import { Card, CardMedia, CardContent, Typography, Button } from '@mui/material';
import robertsImage from '../../assets/homePage/roberts_home.JPG';

export default function RobertsHome() {
    return (
        <Card elevation={3} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardMedia
                component="img"
                image={robertsImage}
                alt="Roberts Home Museum"
                loading="lazy"
                decoding="async"
                sx={{ height: 200, objectFit: 'cover' }}
            />
            <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                    Roberts Home Museum and Hotel
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Step inside the Piedmont Historical Society's Roberts Home Museum and Hotel, the historic home of the Roberts family embedded in Piedmont’s past. We invite you to explore original rooms, learn about 19th-century life, and experience the charm of this restored landmark.
                </Typography>
                <Button
                    variant="contained"
                    href="https://www.nightinthemuseum.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ backgroundColor: '#002F6C', color: 'common.white', '&:hover': { backgroundColor: '#002F6C' } }}
                >
                    Visit Website
                </Button>
            </CardContent>
        </Card>
    );
}
